import { Button } from "primereact/button"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import TableComponent from "../../component/Tables/tableComponent"
import { rundataAssetProfiler } from "../../redux/dataAsset/dataAsset.action"
function SampleDataPopUp({id, onHide }) {
    const { apiData } = useSelector((state) => state.dataAsset)
    const dispatch =useDispatch()
    const getColumns = () => {
        let col = []
        apiData.sampleData.data.map((val) => {
            Object.keys(val).map((val1) => {
                col.push({ field: val1, header: val1,style:{minWidth:"100px",textAlign:"center"} })
            })
        })
        return col
    }
    return <PopUpScreen header="Sample Data" onHide={onHide} style={{ maxWidth: '90%', maxHeight: "100%" }} >
        <TableComponent scrollable scrollHeight="100%" style={{ height: "100%" }} tableData={apiData.sampleData.data} columns={getColumns()} checked={false} />
        {/* <div className="grid">

            <div className="col-12" style={{ marginTop: "10px", textAlign: "right" }}>
                <Button outlined onClick={onHide} label="Close" style={{ marginRight: "10px" }} />
                <Button onClick={()=>{
                    dispatch(rundataAssetProfiler(id))
                    onHide()
                }
                } label="Run Profiler" />
            </div>
        </div> */}
    </PopUpScreen>
}

export default SampleDataPopUp